module.exports = __webpack_public_path__ + "static/media/хе.7d77b292.mp3";